export function downloadBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    // Keep the URL alive until the browser has started consuming the download.
    window.setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export async function createApprovedPrint(client, orderId, state, options = {}) {
    const base = `/vue/cardorders/${orderId}/production`;
    const preview = await client.post(`${base}/prepare`, { ...options, kind: 'tryck', revision: state.revision });
    const response = await client.post(`${base}/save`, { token: preview.data.token });
    const file = response.data.versions[response.data.saved_version];
    if (!file || file.source_proof_id !== state.approved) throw new Error('Tryckfilens korrkälla har ändrats. Ladda om ordern.');
    return { state: response.data, file };
}

export async function downloadPrint(client, orderId, file) {
    const response = await client.get(`${file.url}?download=1`, { responseType: 'blob' });
    downloadBlob(response.data, `tryck-order-${orderId}.pdf`);
}

export async function productionError(error) {
    if (error.response?.data instanceof Blob) {
        try { return JSON.parse(await error.response.data.text()).message || 'Nedladdningen misslyckades.'; } catch (ignored) { return 'Nedladdningen misslyckades.'; }
    }
    return error.response?.data?.message || error.message || 'Åtgärden misslyckades.';
}

export async function downloadIndesign(client, orderId, state) {
    if (!state.approved) throw new Error('Godkänn ett aktuellt korr före InDesign-export.');
    const { data } = await client.post(`/vue/cardorders/${orderId}/production/files/${state.approved}/indesign`, { revision: state.revision });
    if (data.version !== state.approved) throw new Error('Exportens korrversion har ändrats. Ladda om ordern.');
    const response = await client.get(data.url, { responseType: 'blob' });
    downloadBlob(response.data, `order-${orderId}-indesign-${data.version}.zip`);
}

export async function historicalGreetingDesign(client, orderId, version) {
    if (typeof version !== 'string' || !/^[a-f0-9]{32}$/.test(version)) throw new Error('Ogiltig korrversion.');
    const { data } = await client.get(`/vue/cardorders/${orderId}/production/files/${version}/design`);
    if (!data.layout || !Array.isArray(data.layout.objects)) throw new Error('Versionen saknar en redigerbar design.');
    return { ...data, layout: JSON.parse(JSON.stringify(data.layout)) };
}

// The server owns transitions and approval eligibility; this only selects display records.
export function productionState(state) {
    const step = state.step || 'needs_source';
    return {
        step,
        proof: state.versions?.[state.current?.korr] || null,
        approved: state.versions?.[state.approved] || null,
        printFile: state.versions?.[state.current?.tryck] || null,
        needsProof: ['needs_source', 'needs_proof'].includes(step),
        needsApproval: step === 'needs_approval',
        validPrint: state.valid_print === true,
    };
}
